import { BaseType } from '../base/base-type';
import { PrescribedTaxZoneTypeIdEnum } from './prescribed-tax-zone-type-id.enum';

export class PrescribedTaxZoneType extends BaseType {
  public declare id: PrescribedTaxZoneTypeIdEnum;
}
